export default __webpack_public_path__ + "static/media/LogoNeqas.2c5aa975.jpg";